(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  // Legacy app script tags still load Klaviyo. Keep tracking, but use only the theme signup popup.
  const selector = '[role="dialog"][aria-label="POPUP Form"]';
  const clearLegacyPopup = () => {
    document.querySelectorAll(selector).forEach(dialog => {
      if (!dialog.querySelector('form.klaviyo-form')) return;
      const closeButton = dialog.querySelector('button[aria-label*="close" i], .klaviyo-close-form');
      if (closeButton) closeButton.click();
      if (dialog.isConnected) dialog.remove();
    });
    if (document.querySelector(selector)) return;
    const hadScrollLock = document.documentElement.classList.contains('klaviyo-prevent-body-scrolling') ||
      document.body.classList.contains('klaviyo-prevent-body-scrolling');
    if (!hadScrollLock) return;
    if (document.documentElement.classList.contains('klaviyo-prevent-body-scrolling')) document.documentElement.classList.remove('klaviyo-prevent-body-scrolling');
    if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) document.body.classList.remove('klaviyo-prevent-body-scrolling');
    if (document.querySelector('dialog[open], cart-drawer.active, details[open].menu-opening')) return;
    if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
    if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = '';
  };
  let queued = false;
  const queueCleanup = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; clearLegacyPopup(); });
  };
  const start = () => {
    clearLegacyPopup();
    new MutationObserver(queueCleanup).observe(document.body, {childList:true, subtree:true});
    new MutationObserver(queueCleanup).observe(document.documentElement, {attributes:true, attributeFilter:['class']});
    new MutationObserver(queueCleanup).observe(document.body, {attributes:true, attributeFilter:['class']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
